import { FC } from 'react';
import { observer } from 'mobx-react';
import { Box, Drawer, Typography } from '@mui/material';
import VivaConfig from './PaymentConfigs/VivaConfig';
import SwishConfig from './PaymentConfigs/SwishConfig';
import PlusConfig from './PaymentConfigs/PlusConfig';
import RestaurantConfig from './PaymentConfigs/RestaurantConfig';
import RetailConfig from './PaymentConfigs/RetailConfig';
import UserPermissionsConfig from './PaymentConfigs/UserPermissionsConfig';
import EnklaOrderConfig from './PaymentConfigs/EnklaOrderConfig';
import FortnoxInvoiceConfig from './PaymentConfigs/FortnoxInvoiceConfig';
import PersonalkollenConfig from './PaymentConfigs/PersonalkollenConfig';
import NetsConfig from './PaymentConfigs/NetsConfig';
import TidypayConfig from './PaymentConfigs/TidypayConfig';
import SharedSubscriptionConfig from './PaymentConfigs/SharedSubscriptionConfig';

interface ConfigurationDrawerProps {
  open: boolean;
  onClose: () => void;
  selectedItemId: string | null;
}

const ConfigurationDrawer: FC<ConfigurationDrawerProps> = observer(
  ({ open, onClose, selectedItemId }) => {
    const renderConfig = () => {
      if (!selectedItemId) return null;
      switch (selectedItemId) {
        case 'PLUS':
          return <PlusConfig onClose={onClose} />;
        case 'RESTAURANT':
          return <RestaurantConfig onClose={onClose} />;
        case 'RETAIL':
          return <RetailConfig onClose={onClose} />;
        case 'USER_PERMISSIONS':
          return <UserPermissionsConfig onClose={onClose} />;
        case 'ENKLA_ORDER':
          return <EnklaOrderConfig onClose={onClose} />;
        case 'FORTNOX_INVOICE':
          return <FortnoxInvoiceConfig onClose={onClose} />;
        case 'PERSONALKOLLEN':
          return <PersonalkollenConfig onClose={onClose} />;
        case 'NETS_TERMINAL':
          return <NetsConfig onClose={onClose} />;
        case 'VIVA':
          return <VivaConfig onClose={onClose} />;
        case 'VIVA_TERMINAL':
          return <VivaConfig onClose={onClose} isTerminal />;
        case 'SWISH':
          return <SwishConfig onClose={onClose} />;
        case 'TIDYPAY':
          return <TidypayConfig onClose={onClose} />;
        case 'BOOKKEEPING':
          return <SharedSubscriptionConfig onClose={onClose} subscriptionId="BOOKKEEPING" />;
        case 'EXTERNAL_SEARCH':
          return <SharedSubscriptionConfig onClose={onClose} subscriptionId="EXTERNAL_SEARCH" />;
        default:
          return <Typography>Ingen konfiguration tillgänglig för denna betalmetod.</Typography>;
      }
    };

    return (
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        sx={{
          '& .MuiDrawer-paper': {
            width: '100%',
            maxWidth: 800,
          },
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            paddingRight: 4,
            paddingLeft: 4,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {renderConfig()}
        </Box>
      </Drawer>
    );
  },
);

export default ConfigurationDrawer;
